module.exports = __webpack_public_path__ + "static/media/craft_keep_item_first.3ac89d0d.mp3";